export default function marketpriceController(
    $scope,
    articles,
    siteService,
    Scroll
) {
    $scope.articles = articles;
    Scroll.to("main-content-focus", siteService.headerHeight + 15);
}
